import { Button } from 'react-bootstrap';
import { VMS_VIEW_MODES } from '../config/vms.config';
import styles from '../assets/ExacqVision.module.css';
import ViewModeIcon from './ViewModeIcon';

export default function CameraViewControls({ viewMode, onChange }) {
  return (
    <div className={styles['controls-container']} role="group" aria-label="Camera view layout">
      {VMS_VIEW_MODES.map((mode) => (
        <Button
          key={mode.name}
          type="button"
          className={`btn-transparent ${styles['mode-button']}`}
          aria-label={mode.label}
          aria-pressed={viewMode.name === mode.name}
          onClick={() => onChange(mode)}
        >
          <ViewModeIcon count={mode.panelCount} />
        </Button>
      ))}
    </div>
  );
}
